import Logo from '@assets/icons/logo.svg';
import { Separator } from '@base-ui/react';
import cx from 'classnames';
import { RESERVATIONS_SERVICE_PATH } from '../paths';
import styles from './AdminHeader.scss';
import { AvatarDropdown } from './AvatarDropdown';
import layoutStyles from './Layout.scss';
import { NotificationCenter } from './NotificationCenter';
import { PrimaryNavigationTabs } from './PrimaryNavigationTabs';
import { RestaurantSelector } from './RestaurantSelector';

export const AdminHeader = () => {
  return (
    <nav
      aria-label="primary"
      className={cx(layoutStyles.pageMargin, styles.header)}
    >
      <a
        href={RESERVATIONS_SERVICE_PATH}
        aria-label="Peak restaurant admin home"
      >
        <Logo className={styles.logo} />
      </a>
      <RestaurantSelector />
      <PrimaryNavigationTabs />
      <Separator className={styles.separator} />
      <NotificationCenter />
      <AvatarDropdown />
    </nav>
  );
};
